import { AudiencePageTemplate } from '@/components/AudiencePageTemplate'
import { getAudienceSegment } from '@/data/whoWeServe'

export default function PreCollegeSummerProgramsPage() {
  return <AudiencePageTemplate segment={getAudienceSegment('pre-college-summer-programs')} />
}
